import { useLocation, Outlet } from "react-router-dom";
import { useClaims } from "../auth/ClaimsProvider";
import { ShiOnePermission } from "../auth/authorizationTypes";
import FeatureComponent from "../components/FeatureComponent";
import { Card, CardContent, Typography } from "@mui/material";

export default function RoadmapsRecommendationsMiddleware({ children }) {
  const location = useLocation();
  const { hasPermission, isVirtualAdmin } = useClaims();

  const showRoadmaps =
    hasPermission(ShiOnePermission.roadmapsManage) || isVirtualAdmin();

  const isRoadmapRoute = location.pathname.includes("roadmaps");
  const isRecommendationsRoute = location.pathname.includes("recommendations");
  const pathDisplayText = isRoadmapRoute ? "roadmaps" : "recommendations";

  if (isRoadmapRoute || isRecommendationsRoute) {
    if (!showRoadmaps) {
      return (
        <FeatureComponent showDashboard authRequired>
          <div className="flex w-full justify-center">
            <Card>
              <CardContent>
                <Typography
                  variant="h6"
                  color="error"
                  fontWeight="bold"
                  gutterBottom
                >
                  You don't have permissions to view {pathDisplayText}.
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  To view {pathDisplayText} please talk to your Account
                  Executive
                </Typography>
              </CardContent>
            </Card>
          </div>
        </FeatureComponent>
      );
    }
  }

  return children ? children : <Outlet />;
}
